import { render, staticRenderFns } from "./VerifyDOB.vue?vue&type=template&id=23616499&scoped=true"
import script from "./VerifyDOB.vue?vue&type=script&lang=js"
export * from "./VerifyDOB.vue?vue&type=script&lang=js"
import style0 from "./VerifyDOB.vue?vue&type=style&index=0&id=23616499&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23616499",
  null
  
)

export default component.exports